import React from 'react'

const ProcessSpinner = () => {
  return (
    <div class="spinner-border spinner-border-reverse align-self-center text-dark mx-3"></div>

  )
}

export default ProcessSpinner